"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function ApplicationFromJSON(json) {
    return ApplicationFromJSONTyped(json, false);
}
exports.ApplicationFromJSON = ApplicationFromJSON;
function ApplicationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !runtime_1.exists(json, 'status') ? undefined : _1.ApplicationStatusFromJSON(json['status']),
        'affiliation': !runtime_1.exists(json, 'affiliation') ? undefined : _1.AffiliationFromJSON(json['affiliation']),
        'residentialAddress': !runtime_1.exists(json, 'residentialAddress') ? undefined : _1.AddressFromJSON(json['residentialAddress']),
        'mailingAddress': !runtime_1.exists(json, 'mailingAddress') ? undefined : _1.AddressFromJSON(json['mailingAddress']),
        'citizenship': !runtime_1.exists(json, 'citizenship') ? undefined : _1.CitizenshipFromJSON(json['citizenship']),
        'controlPerson': !runtime_1.exists(json, 'controlPerson') ? undefined : _1.ControlPersonFromJSON(json['controlPerson']),
        'investmentProfile': !runtime_1.exists(json, 'investmentProfile') ? undefined : _1.InvestmentProfileFromJSON(json['investmentProfile']),
        'politicalExposure': !runtime_1.exists(json, 'politicalExposure') ? undefined : _1.PoliticalExposureFromJSON(json['politicalExposure']),
        'firstName': !runtime_1.exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !runtime_1.exists(json, 'lastName') ? undefined : json['lastName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'phoneNumber': !runtime_1.exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'ssn': !runtime_1.exists(json, 'ssn') ? undefined : json['ssn'],
        'dateOfBirth': !runtime_1.exists(json, 'dateOfBirth') ? undefined : json['dateOfBirth'],
        'agreement': !runtime_1.exists(json, 'agreement') ? undefined : json['agreement'],
        'signature': !runtime_1.exists(json, 'signature') ? undefined : json['signature'],
        'taxStatus': !runtime_1.exists(json, 'taxStatus') ? undefined : _1.TaxStatusFromJSON(json['taxStatus']),
        'employment': !runtime_1.exists(json, 'employment') ? undefined : _1.EmploymentFromJSON(json['employment']),
        'financialSituation': !runtime_1.exists(json, 'financialSituation') ? undefined : _1.FinancialSituationFromJSON(json['financialSituation']),
        'trustedContactPerson': !runtime_1.exists(json, 'trustedContactPerson') ? undefined : _1.TrustedContactPersonFromJSON(json['trustedContactPerson']),
        'suitability': !runtime_1.exists(json, 'suitability') ? undefined : _1.SuitabilityFromJSON(json['suitability']),
        'sweepProgram': !runtime_1.exists(json, 'sweepProgram') ? undefined : json['sweepProgram'],
    };
}
exports.ApplicationFromJSONTyped = ApplicationFromJSONTyped;
function ApplicationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': _1.ApplicationStatusToJSON(value.status),
        'affiliation': _1.AffiliationToJSON(value.affiliation),
        'residentialAddress': _1.AddressToJSON(value.residentialAddress),
        'mailingAddress': _1.AddressToJSON(value.mailingAddress),
        'citizenship': _1.CitizenshipToJSON(value.citizenship),
        'controlPerson': _1.ControlPersonToJSON(value.controlPerson),
        'investmentProfile': _1.InvestmentProfileToJSON(value.investmentProfile),
        'politicalExposure': _1.PoliticalExposureToJSON(value.politicalExposure),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'middleName': value.middleName,
        'phoneNumber': value.phoneNumber,
        'ssn': value.ssn,
        'dateOfBirth': value.dateOfBirth,
        'agreement': value.agreement,
        'signature': value.signature,
        'taxStatus': _1.TaxStatusToJSON(value.taxStatus),
        'employment': _1.EmploymentToJSON(value.employment),
        'financialSituation': _1.FinancialSituationToJSON(value.financialSituation),
        'trustedContactPerson': _1.TrustedContactPersonToJSON(value.trustedContactPerson),
        'suitability': _1.SuitabilityToJSON(value.suitability),
        'sweepProgram': value.sweepProgram,
    };
}
exports.ApplicationToJSON = ApplicationToJSON;
